import React, { Component } from 'react';
import HeaderAccountList from '../../common/HeaderAccountList';
import { commonLogout, trackTypeObj } from '../../../constants/Common';
import { track } from '../../../services/util';
import IntlMessages from '../../../util/IntlMessages';

const DashboardRight = (props) => {
  let trackData = props && props.tracks;
  let orderData = props && props.orderData;
  return (
    <div className="dashboardRightBlock">
      <div className="dashboardRightInner" style={props.style}>
        <div className="userDetailList">
          <ul>
            <HeaderAccountList
              check
              details={trackData && trackData[trackTypeObj['WATCHLIST']]}
              link="/account/watchlist"
              title={<IntlMessages id="app.my-watchlist" />}
            />
            <HeaderAccountList
              check
              details={trackData && trackData[trackTypeObj['CART']]}
              link="/account/cart"
              title={<IntlMessages id="app.my-cart" />}
            />

            <HeaderAccountList
              check
              details={trackData && trackData[trackTypeObj['OFFICE']]}
              link="/account/office-list"
              title={<IntlMessages id="app.office-list" />}
            />
            <HeaderAccountList
              check
              details={trackData && trackData[trackTypeObj['QUOTE']]}
              link="/account/quote-list"
              title={<IntlMessages id="app.MyOfferList" />}
            />
            <HeaderAccountList
              check
              details={orderData && orderData['order']}
              link="/account/confirm-list"
              title={<IntlMessages id="app.MyOrderedList" />}
            />
            <HeaderAccountList
              check
              details={orderData && orderData['purchased']}
              link="/account/my-purchase"
              title={<IntlMessages id="app.MyPurchaseHistory" />}
            />

            <HeaderAccountList
              check
              link="/account/saved-search"
              title={<IntlMessages id="app.saved-search" />}
              basicDetailnull
            />
            <HeaderAccountList
              check
              link="/account/my-demand"
              title={<IntlMessages id="app.my-demand-tab" />}
              basicDetailnull
            />
            <HeaderAccountList link="/account/profile" title={<IntlMessages id="app.MyProfile" />} basicDetailnull />
            <HeaderAccountList
              link="/account/profile?notification"
              title={<span>Notification Setting</span>}
              basicDetailnull
            />
            <HeaderAccountList
              logout
              link=""
              title={<IntlMessages id="app.Logout" />}
              onClick={() => commonLogout()}
              basicDetailnull
            />
          </ul>
        </div>
      </div>
    </div>
  );
};
export default DashboardRight;
